import { Box } from "@otrium/core";
import styled from "@emotion/styled";
import { Content } from "src/atoms/Content";
import BaseButton from "src/atoms/Button/BaseButton";
import { Button } from "src/atoms/Button";

const CartViewContent = styled(Box)`
  max-width: 1264px;
  margin: 0 auto;
  padding: ${({ theme }) => `${theme.space.space0} ${theme.space.space16}`};
  @media (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    padding: 0;
  }
`;

const CartHeader = styled(Content)`
  max-width: 544px;
  padding: ${({ theme }) => theme.space[0]};
`;

const CartOrderSummaryContent = styled(Box)<{
  isDisabled?: boolean;
}>`
  position: relative;
  color: ${({ theme }) => theme.colors.tone.black};
  background-color: ${({ theme }) => theme.colors.tone.sand};

  ${({ isDisabled, theme }) =>
    isDisabled &&
    `
  &:before {
    width: 100%;
    height: 100%;
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    top: 0;
    left: 0;
    z-index: 1;
    opacity: 0.67;
    background-color: ${theme.colors.tone.sand};
  }
  `}
`;

const ButtonDeleteAllUnavailableItems = styled(BaseButton)`
  border: none;
  background: none;
  cursor: pointer;
`;

const ButtonDeleteCoupon = styled(BaseButton)`
  display: flex;
  place-items: center;
  place-content: center;
  border: none;
  background: none;
  width: ${({ theme }) => theme.space.space16};
  height: ${({ theme }) => theme.space.space16};
  margin-left: ${({ theme }) => theme.space[2]};
  vertical-align: top;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};

  svg {
    width: ${({ theme }) => theme.space._12};
    height: ${({ theme }) => theme.space._12};
  }
`;

const ButtonAddCoupon = styled(BaseButton)`
  border: none;
  background: none;
  display: flex;
  cursor: pointer;
`;

const CartItems = styled(Box)`
  flex-basis: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex-basis: 600px;
    padding-left: ${({ theme }) => theme.space[6]}px;
  }
`;

const CartViewOrderSummaryWrapper = styled(Box)`
  flex-basis: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex-basis: 392px;
  }
`;

const CartViewCarouselsWrapper = styled(Box)`
  flex-basis: 100%;
  margin-top: ${({ theme }) => theme.space[2]}px;
  margin-bottom: ${({ theme }) => theme.space[2]}px;
  max-width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-top: ${({ theme }) => theme.space[5]}px;
    margin-bottom: ${({ theme }) => theme.space[6]}px;
  }
`;

const StyledSmallButton = styled(Button)`
  padding: ${({ theme }) => theme.space[2]}px ${({ theme }) => theme.space[4]}px;
  height: 40px;
`;

export {
  CartViewContent,
  CartHeader,
  CartItems,
  CartViewOrderSummaryWrapper,
  CartViewCarouselsWrapper,
  ButtonDeleteAllUnavailableItems,
  CartOrderSummaryContent,
  ButtonDeleteCoupon,
  ButtonAddCoupon,
  StyledSmallButton,
};
